var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"ma-0 pa-0"},[_c('Navbar',{attrs:{"app":""}}),_c('v-main',[_c('Keeper')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }